// extracted by mini-css-extract-plugin
export var chevron = "_ga-2";
export var dropdownItems = "_ga-0";
export var item = "_ga-1";